import * as React from 'react'

export const SecurityIcon = React.memo<JSX.IntrinsicElements['svg']>(
  (props) => {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 7.75C6 6.64543 6.89543 5.75 8 5.75H34C35.1046 5.75 36 6.64543 36 7.75V33.75C36 34.8546 35.1046 35.75 34 35.75H8C6.89543 35.75 6 34.8546 6 33.75V7.75Z"
          fill="#C6C6C6"
        />
        <path
          d="M12 13.75C12 12.6454 12.8954 11.75 14 11.75H40C41.1046 11.75 42 12.6454 42 13.75V39.75C42 40.8546 41.1046 41.75 40 41.75H14C12.8954 41.75 12 40.8546 12 39.75V13.75Z"
          fill="#5BBBFC"
        />
        <path
          d="M36 11.75V33.75C36 34.8546 35.1046 35.75 34 35.75H12V13.75C12 12.6454 12.8954 11.75 14 11.75H36Z"
          fill="#FAF8F5"
        />
        <path
          d="M26 25.334C27.7659 24.5624 29 22.8003 29 20.75C29 17.9886 26.7614 15.75 24 15.75C21.2386 15.75 19 17.9886 19 20.75C19 22.8003 20.2341 24.5624 22 25.334V29.75C22 30.8546 22.8954 31.75 24 31.75C25.1046 31.75 26 30.8546 26 29.75V25.334Z"
          fill="#001C64"
        />
      </svg>
    )
  },
)

SecurityIcon.displayName = 'SecurityIcon'
